import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import _ from "lodash"
import moment from "moment"
import { Tooltip } from "primereact/tooltip"

import { Button, CalendarField } from "../../../helpers"
import { raiseToast } from "../../../services/redux/reducers/toast/toast"
import { submitPOPunch } from "../../../services/api/poPunch"
import { insertPOSchedule } from "../../../services/api/poSchedule"

const RecurringPoModal = (props) => {
    const {
        selectedColumnId,
        initialPOScheduleItems,
        buyerPO,
        poPunch,
        poPunchItems,
        dispatchNoteItems,
        buyerPOItems,
        setIsLoading,
        getBuyerPO,
        poSchedule,
        setIsReccuringPoModalVisible, datewisePOSchedule, datewisePOScheduleItems, punchingIndex, setDatewisePOSchedule, setDatewisePOScheduleItems
    } = props

    const usersData = useSelector((state) => state.userDetails)
    const [poProcessedDate, setPoProcessedDate] = useState(new Date())
    const [selectedOption, setSelectedOption] = useState('scheduleDate')
    const [scheduleDates, setScheduleDates] = useState([])

    const dispatch = useDispatch()

    const handleProcessedDate = (e) => {
        setPoProcessedDate(e.target.value)
    }

    const handleOptionChange = (e) => {
        setSelectedOption(e.target.value)
    }

    useEffect(() => {
        const updateScheduleDates = () => {
            const relatedScheduledItems = initialPOScheduleItems.filter(
                (each) => each.columnId === selectedColumnId && each.scheduledQty > 0
            )

            const dates = relatedScheduledItems.map((item) => {
                let relatedBuyerPOItem = buyerPOItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === item.buyerPOItemId)
                let scheduleDate, isGrey
                let isRed = false

                if (selectedOption === 'scheduleDate') {
                    scheduleDate = new Date(item.scheduledDate)
                } else {
                    scheduleDate = new Date(poProcessedDate)
                    let udpatedScheduleDate = scheduleDate.getDate() + parseInt(relatedBuyerPOItem?.leadTime)
                    scheduleDate.setDate(udpatedScheduleDate)
                }
                
                const nextPOSchedule = datewisePOSchedule[punchingIndex + 1]

                if(nextPOSchedule?.scheduledDate){
                    isRed = moment(scheduleDate).format("YYYY-MM-DD") >= nextPOSchedule.scheduledDate
                }

                let scheduleDateAsPerLeadTime = new Date()
                let expectedScheduleDate = scheduleDateAsPerLeadTime.getDate() + parseInt(relatedBuyerPOItem?.leadTime)
                scheduleDateAsPerLeadTime.setDate(expectedScheduleDate)

                isGrey = selectedOption === 'scheduleDate' && moment(scheduleDate).format("YYYY-MM-DD") < moment(scheduleDateAsPerLeadTime).format("YYYY-MM-DD")
                return {
                    materialId: item.materialId,
                    qty: item.scheduledQty,
                    leadTime: relatedBuyerPOItem.leadTime,
                    scheduleDate,
                    isRed,
                    isGrey
                }
            })

            setScheduleDates(dates)
        }
        updateScheduleDates()
    }, [poProcessedDate, selectedOption, initialPOScheduleItems, buyerPOItems, selectedColumnId])

    const submitPoPunch = async (useDeliveryPeriod = false) => {
        if (poProcessedDate) {
            const relatedScheduledItems = initialPOScheduleItems.filter(
                (each) => each.columnId === selectedColumnId
            )
            let updatedBuyerPOItems = buyerPOItems.map((eachBuyerPOItem) => {
                const relatedScheduledItem = relatedScheduledItems.find(
                    (item) => item.buyerPOItemId === eachBuyerPOItem.buyerPOItemId
                );
                return {
                    ...eachBuyerPOItem,
                    punchQty: relatedScheduledItem?.scheduledQty,
                    poScheduleItemId: relatedScheduledItem?.poScheduleItemId,
                }
            })
            updatedBuyerPOItems = updatedBuyerPOItems.filter(
                (eachBuyerPOItem) => eachBuyerPOItem.punchQty > 0
            )

            let updatedBuyerPOItemsWithDates = []
            if (useDeliveryPeriod) {
                updatedBuyerPOItemsWithDates = updatedBuyerPOItems.map((item) => {
                    let expectedDeliveryDate = new Date(poProcessedDate)
                    let expectedDelivery = expectedDeliveryDate.getDate() + parseInt(item?.leadTime)
                    expectedDeliveryDate.setDate(expectedDelivery)
                    return { ...item, expectedDeliveryDate, statusId: 1, createdAt: new Date(), updatedAt: new Date()}
                })
            } else {
                updatedBuyerPOItemsWithDates = updatedBuyerPOItems.map((item) => {
                    return {
                        ...item,
                        expectedDeliveryDate: new Date(relatedScheduledItems[0].scheduledDate),
                        statusId: 1,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    }
                })
            }

            let poPunchData = {
                buyerPOId: buyerPO.buyerPOId,
                buyerPO: {
                    buyerPOId: buyerPO?.buyerPOId,
                    buyerReqId: buyerPO?.buyerReqId,
                    fileNo: buyerPO?.fileNo,
                    docNo: buyerPO?.docNo,
                    poProcessedDate: poProcessedDate,
                    shipAddrId: buyerPO?.shipAddrId,
                    pmBillAddrId: buyerPO?.pmBillAddrId,
                    createdBy: usersData?.userId,
                    updatedBy: usersData?.userId,
                },
                buyerPOItems: updatedBuyerPOItemsWithDates,
                poPunch: poPunch,
            }

            if (window.confirm("Do You Want to Submit the Punch?")) {
                const poPunchResponse = await submitPOPunch(poPunchData)
                if (poPunchResponse?.failure) {
                    dispatch(raiseToast({ severity: "error", summary: "PO Punch", detail: poPunchResponse?.data?.error, life: 3000 })
                    )
                } else {
                    dispatch(raiseToast({ severity: "success", summary: "Success", detail: "PO Punch is Done", life: 3000 }))
                    setIsReccuringPoModalVisible(false)
                    getBuyerPO()
                }
            }
        } else {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: "error", summary: "PO Punch", detail: "Please select po processed date", life: 3000 }))
        }
    }

    const submitPoPunchAsPerDeliveryPeriod = async (useDeliveryPeriod = false) => {
        if (poProcessedDate) {
            const activeRoleId = usersData?.activeRoleId
            const relatedUserCompany = usersData?.rolesList?.find(eachRole => eachRole?.userRoleId === activeRoleId)
            const relatedScheduledItems = initialPOScheduleItems.filter(
                (each) => each.columnId === selectedColumnId
            )

            const newPoScheduledItems = relatedScheduledItems.map((eachScheduleItem) => {
                const relatedBuyerPOItem = buyerPOItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === eachScheduleItem.buyerPOItemId)
                let expectedDeliveryDate = new Date(poProcessedDate)
                let expectedDelivery = expectedDeliveryDate.getDate() + parseInt(relatedBuyerPOItem?.leadTime)
                expectedDeliveryDate.setDate(expectedDelivery)

                return {
                    buyerPOItemId : eachScheduleItem?.buyerPOItemId,
                    fileNo : eachScheduleItem?.fileNo,
                    docNo: eachScheduleItem?.docNo,
                    buyerReqId : eachScheduleItem?.buyerReqId,
                    buyerPOId : eachScheduleItem?.buyerPOId,
                    buyerReqItemId : eachScheduleItem?.buyerReqItemId,
                    scheduledQty : eachScheduleItem?.scheduledQty,
                    scheduledDate: moment(expectedDeliveryDate).format("YYYY-MM-DD"),
                    createdBy : usersData?.userId,
                    updatedBy : usersData?.userId,
                    leadTime : eachScheduleItem?.leadTime,
                    pmCompanyId : relatedUserCompany?.pmCompanyId,
                    pmBranchId : buyerPO?.pmBranchId,
                    poScheduleItemId : eachScheduleItem?.poScheduleItemId,
                    statusId: 1 
                }
            })

            let triggerReschedule = false
            const currPoScheduledDate = datewisePOSchedule.find(each => each.columnId === selectedColumnId)
            if (currPoScheduledDate) {
                const allDatesMatch = newPoScheduledItems.every(
                    (item) => item.scheduledDate === currPoScheduledDate.scheduledDate
                )

                triggerReschedule = !allDatesMatch
            }
            let rescheduleResData = []

            if (triggerReschedule) {
                if (window.confirm("Do You Want to Submit the Punch?")) {
                    let updatedPOScheduleItems = []
                    const punchedScheduleItemIds = []
                    const dispatchedScheduleItemIds = []
                    const filteredDatewisePOScheduleItems = datewisePOScheduleItems.filter(item => item.columnId !== selectedColumnId)
                    filteredDatewisePOScheduleItems?.map(eachPOScheduleItem => {
                        const relatedPOSchedule = datewisePOSchedule?.find(eachPOSchedule => eachPOSchedule?.columnId === eachPOScheduleItem?.columnId)
                        const relatedPoPunchItem = poPunchItems.find(each => each?.poScheduleItemId === eachPOScheduleItem.poScheduleItemId)
                        const relatedDispatchNoteItem = dispatchNoteItems.find(each => each?.poScheduleItemId === eachPOScheduleItem.poScheduleItemId)
                        let updatedPOScheduleItem = {
                            buyerPOItemId: eachPOScheduleItem?.buyerPOItemId,
                            fileNo: eachPOScheduleItem?.fileNo,
                            docNo: eachPOScheduleItem?.docNo,
                            buyerReqId: eachPOScheduleItem?.buyerReqId,
                            buyerPOId: eachPOScheduleItem?.buyerPOId,
                            buyerReqItemId: eachPOScheduleItem?.buyerReqItemId,
                            scheduledQty: eachPOScheduleItem?.scheduledQty,
                            scheduledDate: relatedPOSchedule?.scheduledDate,
                            createdBy: usersData?.userId,
                            updatedBy: usersData?.userId,
                            leadTime: eachPOScheduleItem?.leadTime,
                            pmCompanyId: relatedUserCompany?.pmCompanyId,
                            pmBranchId: buyerPO?.pmBranchId,
                            poScheduleItemId: eachPOScheduleItem?.poScheduleItemId,
                            poPunchItemId: relatedPoPunchItem?.poPunchItemId,
                            dispatchNoteItemId: eachPOScheduleItem?.dispatchNoteItemId,
                            statusId: 1
                        }
                        if (updatedPOScheduleItem?.scheduledQty > 0) {
                            updatedPOScheduleItems.push(updatedPOScheduleItem)
                        }
                        if (relatedPoPunchItem?.poScheduleItemId) {
                            punchedScheduleItemIds.push(relatedPoPunchItem.poScheduleItemId)
                        }
                        if (relatedDispatchNoteItem?.poScheduleItemId) {
                            dispatchedScheduleItemIds.push(relatedDispatchNoteItem.poScheduleItemId)
                        }
                    })
                    const allPoScheduleItems = [...newPoScheduledItems, ...updatedPOScheduleItems]
                    let latestPOSchedule = _.maxBy(poSchedule, "poScheduleId")

                    let data = {
                        poScheduleId: latestPOSchedule?.poScheduleId,
                        poSchedule: {
                            buyerPOId: buyerPO?.buyerPOId,
                            buyerReqId: buyerPO?.buyerReqId,
                            fileNo: buyerPO?.fileNo,
                            docNo: buyerPO?.docNo,
                            pmBillAddrId: buyerPO?.pmBillAddrId,
                            pmCompanyId: relatedUserCompany?.pmCompanyId,
                            pmBranchId: buyerPO?.pmBranchId,
                            statusId: 1,
                            createdBy: usersData?.userId,
                            updatedBy: usersData?.userId,
                            poRescheduleReasonId: 4   // default reason -> "Client Ask"
                        },
                        poScheduleItems: allPoScheduleItems,
                        prevPOSchedule: poSchedule,
                        buyerPOId: buyerPO?.buyerPOId,
                        punchedScheduleItemIds: punchedScheduleItemIds,
                        dispatchedScheduleItemIds: dispatchedScheduleItemIds
                    }
                    setIsLoading(true)
                    const rescheduleItemResponse = await insertPOSchedule(data)
                    rescheduleResData = rescheduleItemResponse.data
                    setIsLoading(false)

                    await handlePoPunch(rescheduleResData, newPoScheduledItems, triggerReschedule)
                }
            } else {
                if (window.confirm("Do You Want to Submit the Punch?")) {
                    await handlePoPunch(rescheduleResData, newPoScheduledItems, triggerReschedule)
                }
            }

        } else {
            setIsLoading(false);
            return dispatch(raiseToast({ severity: "error", summary: "PO Punch", detail: "Please select po processed date", life: 3000 }));
        }
    }

    const handlePoPunch = async (rescheduleResData, newPoScheduledItems, triggerReschedule) => {
        let updatedBuyerPOItems = buyerPOItems.map((eachBuyerPOItem) => {
            const relatedNewPOScheduleItem = newPoScheduledItems.find(
                (item) => item.buyerPOItemId === eachBuyerPOItem.buyerPOItemId
            )
            let poScheduleItemId = null
            if(triggerReschedule){
                const relatedMapping = rescheduleResData?.find(each => each?.oldPoScheduleItemId === relatedNewPOScheduleItem?.poScheduleItemId)
                poScheduleItemId = relatedMapping?.newPoScheduleItemId
            }
            else{
                poScheduleItemId = relatedNewPOScheduleItem?.poScheduleItemId
            }
            return {
                ...eachBuyerPOItem,
                punchQty: relatedNewPOScheduleItem?.scheduledQty,
                expectedDeliveryDate: relatedNewPOScheduleItem?.scheduledDate,
                poScheduleItemId: poScheduleItemId,
                createdAt: new Date(),
                updatedAt: new Date(),
                statusId : 1
            }
        })

        updatedBuyerPOItems = updatedBuyerPOItems.filter(
            (eachBuyerPOItem) => eachBuyerPOItem.punchQty > 0
        )

        let poPunchData = {
            buyerPOId: buyerPO.buyerPOId,
            buyerPO: {
                buyerPOId: buyerPO?.buyerPOId,
                buyerReqId: buyerPO?.buyerReqId,
                fileNo: buyerPO?.fileNo,
                docNo: buyerPO?.docNo,
                poProcessedDate: poProcessedDate,
                shipAddrId: buyerPO?.shipAddrId,
                pmBillAddrId: buyerPO?.pmBillAddrId,
                createdBy: usersData?.userId,
                updatedBy: usersData?.userId,
            },
            buyerPOItems: updatedBuyerPOItems,
            poPunch: poPunch,
        }

        setIsLoading(true)
        const poPunchResponse = await submitPOPunch(poPunchData)
        setIsLoading(false)
        if (poPunchResponse?.failure) {
            dispatch(raiseToast({ severity: "error", summary: "PO Punch", detail: poPunchResponse?.data?.error, life: 3000 }))
        } else {
            dispatch(raiseToast({severity: "success", summary: "Success", detail: "PO Punch is Done", life: 3000}));
            setIsReccuringPoModalVisible(false)
            getBuyerPO()
        }
    }
    let minPoProcessedDate = new Date()
    minPoProcessedDate.setDate(minPoProcessedDate.getDate() - 4)
    const isPunchButtonDisabled = scheduleDates.some(date => date.isRed)
    return (
        <>
            <div id="" style={{ display: 'flex', alignItems: 'center',  }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ marginBottom: '5px' }}>PO Processed Date<span style={{color:"red"}} className="from-required">*</span></label>
                    <CalendarField
                        minDate={minPoProcessedDate}
                        maxDate={new Date()}
                        value={poProcessedDate}
                        onChange={handleProcessedDate}
                        required
                    />
                </div>
    
                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '15px' }}>
                    <label style={{ marginBottom: '5px',  }}>Punch As Per:</label>
                    <div style={{
                        padding: '9px',
                        border: '1px solid #ddd',
                        borderRadius: '7px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        height: '34px'
                    }}>
                        <label style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                            <input
                                type="radio"
                                value="scheduleDate"
                                checked={selectedOption === 'scheduleDate'}
                                onChange={handleOptionChange}
                            /> Scheduled Date
                        </label>
                        {/*<label style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                type="radio"
                                value="deliveryPeriod"
                                checked={selectedOption === 'deliveryPeriod'}
                                onChange={handleOptionChange}
                            /> Delivery Period
                        </label>*/}
                    </div>
                </div>
            </div>
    
            <div className="req-details-modal mb-1 justify-content-center mt-4">
                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
                    <thead>
                        <tr>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Material ID</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Qty</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Lead Time</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Schedule Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {scheduleDates.map((item, index) => (
                            <tr key={index}>
                                <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>{item.materialId}</td>
                                <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>{item.qty}</td>
                                <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>{item.leadTime}</td>
                                <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                                    <span style={{ color: item.isRed ? 'red' : item.isGrey ? 'grey' : 'green' }}>
                                        {moment(item.scheduleDate).format('YYYY-MM-DD')}
                                    </span>
                                    {item.isRed && (
                                        <>
                                            <i className="pi pi-exclamation-triangle custom-tooltip-exclamation-triangle" style={{ color: 'red', marginLeft: '5px' }}></i>
                                            <Tooltip target={`.custom-tooltip-exclamation-triangle`} position="top" autoHide>
                                                This item's expected delivery date exceeds the next unpunched scheduled date. <br /> Please reschedule before proceeding with this option.
                                            </Tooltip>
                                        </>
                                    )}
                                    {item.isGrey && (
                                        <>
                                            <i className="pi pi-exclamation-circle custom-tooltip-exclamation-circle" style={{ color: 'grey', marginLeft: '5px' }}></i>
                                            <Tooltip target={`.custom-tooltip-exclamation-circle`} position="top" autoHide>
                                                The quoted lead time isn't enough to deliver on this date, are you sure you want to continue?
                                            </Tooltip>
                                        </>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
                    <Button
                        label="PUNCH"
                        onClick={() => {
                            selectedOption === 'scheduleDate' ? submitPoPunch() : submitPoPunchAsPerDeliveryPeriod()
                        }}
                        disabled={isPunchButtonDisabled}
                        applyThrottle={true}
                    />
                </div>
            </div>
        </>
    )
}

export default RecurringPoModal
